import api from "./api";
import { getApiUrl } from "./config";
import { endpoint } from "./endpoints";
import { handleApiCall } from "../utils/apiResponseHandler";

export interface AgencyStatus {
  isOwner: boolean;
  hasAgency: boolean;
  accountType: 'trial' | 'lite' | 'basic' | 'full_fledged' | 'enterprise' | 'super_agent' | 'dialer';
  selectedPlan?: string;
  agencyId?: string;
  ownedAgencyId?: string; // ID of the agency the user owns (regardless of current context)
  role?: 'owner' | 'admin' | 'agent' | 'viewer';
  isSystemAdmin?: boolean; // System admin flag (userType: 'admin')
  userType?: string; // User type from backend
}

export const agencyStatusService = {
  async getMyStatus(): Promise<AgencyStatus> {
    try {
      const result = await handleApiCall<AgencyStatus>(async () => {
        const res = await api.get<{ data?: AgencyStatus } | AgencyStatus>({
          url: getApiUrl(endpoint.agencies.myStatus),
        });
        return res;
      });
      return result;
    } catch (error) {

      throw error;
    }
  },
};

export default agencyStatusService;

